import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getTraceRulerEnabled = (state: RootState) => state.pages.editor.canvas.isTraceRulerEnabled;

const isTraceRulerEnabled = createSelector([getTraceRulerEnabled], (enabled) => enabled);

export default isTraceRulerEnabled;
